import '@/speech-recognition-init';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import './index.css';
import './tenant-brand-font.css';
import 'react-toastify/dist/ReactToastify.css';

const container = document?.getElementById('root');
if (container) {
  const root = createRoot(container);

  root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
  );
}
